/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum AddressType {
    MailingAddress = 0,
    BillingAddress = 1,
}
